var _Path, _Circle, _Path2, _Path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Path, Circle } from "react-native-svg";
var SvgUsers = function SvgUsers(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-users"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
  })), _Circle || (_Circle = /*#__PURE__*/React.createElement(Circle, {
    cx: 9,
    cy: 7,
    r: 4
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    d: "M23 21v-2a4 4 0 0 0-3-3.87"
  })), _Path3 || (_Path3 = /*#__PURE__*/React.createElement(Path, {
    d: "M16 3.13a4 4 0 0 1 0 7.75"
  })));
};
export default SvgUsers;